module.exports = __webpack_public_path__ + "fonts/Gibson.e299136e.woff";